import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Minus, Plus, Ticket, Trash2, X } from 'lucide-react';
import { HOOKS, hook } from '../../lib/domHooks';

// Kupon paneli. Hesaplamalar hook'ta (useSportsbook) yapılır; burada yalnızca
// çizim vardır — freebet seçiliyken bahis tutarı hakkın kendisidir ve kazançta
// iade edilmediği için "Muhtemel Net Kazanç" yazar.

const QUICK_STAKES = [50, 100, 250, 500];

const BetSlip = ({
  coupon, removePick, clearCoupon, stake, setStake, totalOdd, winPossible,
  effectiveStake, freebets, freebetId, setFreebetId, activeFreebet,
  freebetOddShort, placeBet, submitting, onClose,
}) => (
  <aside {...hook(HOOKS.BET_SLIP)} className="sb-slip" id="sports-coupon">
    <div className="sb-slip-head">
      <Ticket size={15} />
      Kuponum
      <span className="sb-count">{coupon.length} seçim</span>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="sb-slip-close"
          title="Kuponu gizle"
        >
          <X size={15} />
        </button>
      )}
      {coupon.length > 0 && (
        <button
          type="button"
          onClick={clearCoupon}
          className="sb-pick-remove"
          title="Kuponu temizle"
        >
          <Trash2 size={13} />
        </button>
      )}
    </div>

    {coupon.length === 0 ? (
      <div className="sb-slip-empty">
        Kupon boş. Listeden bir orana dokunun.
      </div>
    ) : (
      <div className="sb-slip-body">
        {coupon.map((pick) => (
          <div key={pick.match_id} className="sb-pick">
            <div className="sb-pick-main">
              <div className="sb-pick-teams">{pick.home} - {pick.away}</div>
              <div className="sb-pick-label">
                {pick.label || `Maç Sonucu: ${pick.pick_key}`}
                <span className="sb-pick-odd">{pick.odd.toFixed(2)}</span>
              </div>
            </div>
            <button
              type="button"
              className="sb-pick-remove"
              onClick={() => removePick(pick.match_id)}
            >
              <X size={13} />
            </button>
          </div>
        ))}
      </div>
    )}

    <div className="sb-slip-foot">
      <div className="sb-row">
        <span>Toplam Oran</span>
        <strong>{totalOdd.toFixed(2)}</strong>
      </div>

      {freebets.length > 0 && (
        <select value={freebetId} onChange={(e) => setFreebetId(e.target.value)}>
          <option value="">Bakiyemden oyna</option>
          {freebets.map((item) => (
            <option key={item.id} value={item.id}>
              {`${item.title} — ${Number(item.amount).toFixed(2)} ₺`}
              {Number(item.min_odd) > 1 ? ` (min ${Number(item.min_odd).toFixed(2)})` : ''}
            </option>
          ))}
        </select>
      )}

      {activeFreebet ? (
        <div className="sb-freebet-note">
          Ücretsiz bahis: <strong>{effectiveStake.toFixed(2)} ₺</strong> — bakiyenizden
          düşülmez, kazançta bahis tutarı iade edilmez.
          {freebetOddShort && (
            <span style={{ display: 'block', color: '#fda4af', marginTop: 4 }}>
              Toplam oran en az {Number(activeFreebet.min_odd).toFixed(2)} olmalı.
            </span>
          )}
        </div>
      ) : (
        <>
          <div className="sb-stake">
            <button type="button" onClick={() => setStake((s) => Math.max(10, s - 10))}>
              <Minus size={14} />
            </button>
            <input
              type="number"
              value={stake}
              onChange={(e) => setStake(Number(e.target.value) || 0)}
            />
            <button type="button" onClick={() => setStake((s) => s + 10)}>
              <Plus size={14} />
            </button>
          </div>
          <div className="sb-quick">
            {QUICK_STAKES.map((value) => (
              <button key={value} type="button" onClick={() => setStake(value)}>
                {value} ₺
              </button>
            ))}
          </div>
        </>
      )}

      <div className="sb-row">
        <span>{activeFreebet ? 'Muhtemel Net Kazanç' : 'Muhtemel Kazanç'}</span>
        <strong>{winPossible.toFixed(2)} ₺</strong>
      </div>

      <button
        type="button"
        className="sb-submit"
        onClick={placeBet}
        disabled={submitting || freebetOddShort || coupon.length === 0}
      >
        {submitting && <Loader2 size={14} className="animate-spin" />}
        Kuponu Onayla
      </button>
    </div>

    {/* Oynanan kuponun nerede görüneceği belli değildi; bağlantı doğrudan üye
        panelindeki kupon listesine gider. */}
    <Link to="/hesap/bahis-kuponlari" className="sb-slip-link">
      <Ticket size={11} /> Oynanan kuponlarım
    </Link>
  </aside>
);

export default BetSlip;
